export const isGermanMarket = (market: string): boolean => {
  return market === 'de_AT' || market === 'de_CH' || market === 'de_DE';
};
